/**
 * Configuration setter enum for Customize options
 * @property {string} UI_SHOW_HEADER
 * @property {string} UI_SHOW_SAVE
 * @readonly
 * @enum string
 */
export const LOS_CUSTOMIZE_CONFIG = Object.freeze({
  UI_SHOW_HEADER: "uiShowHeader",
  UI_SHOW_SAVE: "uiShowSave",
});

export const LOS_CUSTOMIZE_EVENT = Object.freeze({
  DATA_SAVE: "acc-los-data-customize-save",
  DATA_UPDATED: "acc-los-data-customize-updated",
});

export const LOS_SAVED_VIEW = Object.freeze({
  VIEW_KEY: "accWcLosCustomizedFields",
  VIEW_DISPLAY_NAME: "RW LOS Default View",
  CUSTOMIZED_FIELDS: "accWcLosCustomizedFields",
});

export const ED_LOS_SAVED_VIEW = Object.freeze({
  VIEW_KEY: "accWcEdLosCustomizedFields",
  VIEW_DISPLAY_NAME: "ED LOS Default View",
  CUSTOMIZED_FIELDS: "accWcEdLosCustomizedFields",
});

export const CUSTOMIZED_FIELDS_KEY = Object.freeze({
  los: "accWcLosCustomizedFields",
  edlos: "accWcEdLosCustomizedFields",
  watchlist: "accWcLosCustomizedFields",
});

export const LOS_TYPE_SAVED_VIEW = Object.freeze({
  los: LOS_SAVED_VIEW,
  edlos: ED_LOS_SAVED_VIEW,
});
